export default "{\n    \"getPaidOn\": \"Get paid on {{date}}\"\n}\n"